import { DateTimeRange } from '@modules/common/components/DateRangePicker/types';
import dayjs from 'dayjs';

export const getDateTimeRangeFromTimestamp = (
  startTimestamp: number,
  endTimestamp: number,
): DateTimeRange => {
  const currentTimestamp = Date.now() / 1000;
  const endTimeDuration =
    endTimestamp > currentTimestamp ? currentTimestamp : endTimestamp;

  return {
    type: 'absolute',
    startAfter: dayjs.unix(startTimestamp),
    endBefore: dayjs.unix(endTimeDuration),
  };
};
